import styled from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100vw;
`;

export const MaiColumnnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 92vw;
  max-width: ${props => props.theme.layout.maxWidth};
`;
